import { useContext } from "react"
import { GrapghContext } from "../providers/graphs-provider"

const UseGraph = () => {
    const data = useContext(GrapghContext)

    return data
}

export default UseGraph